const types = {
  /**
   * AUTH
   */
  // LOGIN
  LOGIN_START: 'LOGIN_START',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAILURE: 'LOGIN_FAILURE',
  // LOGOUT
  LOGOUT_START: 'LOGOUT_START',
  LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
  LOGOUT_FAILURE: 'LOGOUT_FAILURE',

  // GET_ADMIN
  GET_ADMIN_START: 'GET_ADMIN_START',
  GET_ADMIN_SUCCESS: 'GET_ADMIN_SUCCESS',
  GET_ADMIN_FAILURE: 'GET_ADMIN_FAILURE',

   // PROJECT
  GET_PROJECT_START: 'GET_PROJECT_START',
  GET_PROJECT_SUCCESS: 'GET_PROJECT_SUCCESS',
  GET_PROJECT_FAILURE: 'GET_PROJECT_FAILURE',
  GET_PROJECT_ACCOUNT_START: 'GET_PROJECT_ACCOUNT_START',

  /**
   * USERS
   */
  // -----// GET_USERS //-----//
  GET_USERS_START: 'GET_USERS_START',
  GET_USERS_SUCCESS: 'GET_USERS_SUCCESS',
  GET_USERS_FAILURE: 'GET_USERS_FAILURE',
  // -----// BLOCK_USER //-----//
  BLOCK_USER_START: 'BLOCK_USER_START',
  BLOCK_USER_SUCCESS: 'BLOCK_USER_SUCCESS',
  BLOCK_USER_FAILURE: 'BLOCK_USER_FAILURE',
  // -----// DELETE_USER //-----//
  DELETE_USER_START: 'DELETE_USER_START',
  DELETE_USER_SUCCESS: 'DELETE_USER_SUCCESS',
  DELETE_USER_FAILURE: 'DELETE_USER_FAILURE',
  VERIFICATION_USER: 'VERIFICATION_USER',

  /**
   * USER_ACCOUNT
   */
  // -----// GET_USER_ACCOUNT //-----//
  GET_USER_ACCOUNT_START: 'GET_USER_ACCOUNT_START',
  GET_USER_ACCOUNT_SUCCESS: 'GET_USER_ACCOUNT_SUCCESS',
  GET_USER_ACCOUNT_FAILURE: 'GET_USER_ACCOUNT_FAILURE',
  // -----// PUT_DISABLE_2FA //-----//
  PUT_DISABLE_2FA_START: 'PUT_DISABLE_2FA_START',
  PUT_DISABLE_2FA_SUCCESS: 'PUT_DISABLE_2FA_SUCCESS',
  PUT_DISABLE_2FA_FAILURE: 'PUT_DISABLE_2FA_FAILURE',
  // -----// GET_EXCHANGE_ORDERS //-----//
  GET_EXCHANGE_ORDERS_START: 'GET_EXCHANGE_ORDERS_START',
  GET_EXCHANGE_ORDERS_SUCCESS: 'GET_EXCHANGE_ORDERS_SUCCESS',
  GET_EXCHANGE_ORDERS_FAILURE: 'GET_EXCHANGE_ORDERS_FAILURE',
  // -----// GET_INSTANT_EXCHANGE_ORDERS //-----//
  GET_INSTANT_EXCHANGE_ORDERS_START: 'GET_INSTANT_EXCHANGE_ORDERS_START',
  GET_INSTANT_EXCHANGE_ORDERS_SUCCESS: 'GET_INSTANT_EXCHANGE_ORDERS_SUCCESS',
  GET_INSTANT_EXCHANGE_ORDERS_FAILURE: 'GET_INSTANT_EXCHANGE_ORDERS_FAILURE',
  // -----// GET_EXCHANGE_BALANCE //-----//
  GET_EXCHANGE_BALANCE_START: 'GET_EXCHANGE_BALANCE_START',
  GET_EXCHANGE_BALANCE_SUCCESS: 'GET_EXCHANGE_BALANCE_SUCCESS',
  GET_EXCHANGE_BALANCE_FAILURE: 'GET_EXCHANGE_BALANCE_FAILURE',
  // -----// UPDATE_USER_BALANCE //-----//
  UPDATE_USER_BALANCE_START: 'UPDATE_USER_BALANCE_START',
  UPDATE_USER_BALANCE_SUCCESS: 'UPDATE_USER_BALANCE_SUCCESS',
  UPDATE_USER_BALANCE_FAILURE: 'UPDATE_USER_BALANCE_FAILURE',
  // -----// GET_MARGIN_BALANCE //-----//
  GET_MARGIN_BALANCE_START: 'GET_MARGIN_BALANCE_START',
  GET_MARGIN_BALANCE_SUCCESS: 'GET_MARGIN_BALANCE_SUCCESS',
  GET_MARGIN_BALANCE_FAILURE: 'GET_MARGIN_BALANCE_FAILURE',
  // -----// GET_TRANSACTIONS_HISTORY //-----//
  GET_TRANSACTIONS_HISTORY_START: 'GET_TRANSACTIONS_HISTORY_START',
  GET_TRANSACTIONS_HISTORY_SUCCESS: 'GET_TRANSACTIONS_HISTORY_SUCCESS',
  GET_TRANSACTIONS_HISTORY_FAILURE: 'GET_TRANSACTIONS_HISTORY_FAILURE',
  // -----// GET_TRANSACTIONS_FIAT_HISTORY //-----//
  GET_TRANSACTIONS_HISTORY_FIAT_START: 'GET_TRANSACTIONS_FIAT_HISTORY_START',
  GET_TRANSACTIONS_HISTORY_FIAT_SUCCESS: 'GET_TRANSACTIONS_FIAT_HISTORY_SUCCESS',
  GET_TRANSACTIONS_HISTORY_FIAT_FAILURE: 'GET_TRANSACTIONS_FIAT_HISTORY_FAILURE',
  // -----// GET_REPLENISHED_HISTORY //-----//
  GET_REPLENISHED_HISTORY_START: 'GET_REPLENISHED_HISTORY_START',
  GET_REPLENISHED_HISTORY_SUCCESS: 'GET_REPLENISHED_HISTORY_SUCCESS',
  GET_REPLENISHED_HISTORY_FAILURE: 'GET_REPLENISHED_HISTORY_FAILURE',
  // -----// GET_MARGIN_HISTORY //-----//
  GET_MARGIN_HISTORY_START: 'GET_MARGIN_HISTORY_START',
  GET_MARGIN_HISTORY_SUCCESS: 'GET_MARGIN_HISTORY_SUCCESS',
  GET_MARGIN_HISTORY_FAILURE: 'GET_MARGIN_HISTORY_FAILURE',
  // -----// GET_MARGIN_REPAYMENT //-----//
  GET_MARGIN_REPAYMENT_START: 'GET_MARGIN_REPAYMENT_START',
  GET_MARGIN_REPAYMENT_SUCCESS: 'GET_MARGIN_REPAYMENT_SUCCESS',
  GET_MARGIN_REPAYMENT_FAILURE: 'GET_MARGIN_REPAYMENT_FAILURE',
  // -----// GET_MARGIN_TRANSFERS //-----//
  GET_MARGIN_TRANSFERS_START: 'GET_MARGIN_TRANSFERS_START',
  GET_MARGIN_TRANSFERS_SUCCESS: 'GET_MARGIN_TRANSFERS_SUCCESS',
  GET_MARGIN_TRANSFERS_FAILURE: 'GET_MARGIN_TRANSFERS_FAILURE',
  // -----// UPDATE_USER_STATUS //-----//
  UPDATE_USER_STATUS_START: 'UPDATE_USER_STATUS_START',
  UPDATE_KYC_STATUS_DOCUMENT: 'UPDATE_KYC_STATUS_DOCUMENT',

  UPDATE_USER_STATUS_SUCCESS: 'UPDATE_USER_STATUS_SUCCESS',
  UPDATE_USER_STATUS_FAILURE: 'UPDATE_USER_STATUS_FAILURE',
  // -----// GET_USER_KYC_VERIFICATIONS //-----//
  GET_USER_KYC_VERIFICATIONS_START: 'GET_USER_KYC_VERIFICATIONS_START',
  GET_USER_KYC_VERIFICATIONS_SUCCESS: 'GET_USER_KYC_VERIFICATIONS_SUCCESS',
  GET_USER_KYC_VERIFICATIONS_FAILURE: 'GET_USER_KYC_VERIFICATIONS_FAILURE',
  // -----// UPDATE_USER_KYC_VERIFICATIONS //-----//
  UPDATE_USER_KYC_VERIFICATIONS_START: 'UPDATE_USER_KYC_VERIFICATIONS_START',
  UPDATE_USER_KYC_VERIFICATIONS_SUCCESS: 'UPDATE_USER_KYC_VERIFICATIONS_SUCCESS',
  UPDATE_USER_KYC_VERIFICATIONS_FAILURE: 'UPDATE_USER_KYC_VERIFICATIONS_FAILURE',
  // -----// GET_VERIFY_USER_KYC_STATUS //-----//
  GET_VERIFY_USER_KYC_STATUS_START: 'GET_VERIFY_USER_KYC_STATUS_START',
  GET_VERIFY_USER_KYC_STATUS_SUCCESS: 'GET_VERIFY_USER_KYC_STATUS_SUCCESS',
  GET_VERIFY_USER_KYC_STATUS_FAILURE: 'GET_VERIFY_USER_KYC_STATUS_FAILURE',
  // -----// CHECK_VERIFY_USER_KYC_STATUS //-----//
  CHECK_VERIFY_USER_KYC_STATUS_START: 'CHECK_VERIFY_USER_KYC_STATUS_START',
  CHECK_VERIFY_USER_KYC_STATUS_SUCCESS: 'CHECK_VERIFY_USER_KYC_STATUS_SUCCESS',
  CHECK_VERIFY_USER_KYC_STATUS_FAILURE: 'CHECK_VERIFY_USER_KYC_STATUS_FAILURE',
  // -----// GET_USER_HOT_TRANSACTIONS //-----//
  GET_USER_HOT_TRANSACTIONS_START: 'GET_USER_HOT_TRANSACTIONS_START',
  GET_USER_HOT_TRANSACTIONS_SUCCESS: 'GET_USER_HOT_TRANSACTIONS_SUCCESS',
  GET_USER_HOT_TRANSACTIONS_FAILURE: 'GET_USER_HOT_TRANSACTIONS_FAILURE',
  // -----// GET_USER_LOGIN_HISTORY //-----//
  GET_USER_LOGIN_HISTORY_START: 'GET_USER_LOGIN_HISTORY_START',
  GET_USER_LOGIN_HISTORY_SUCCESS: 'GET_USER_LOGIN_HISTORY_SUCCESS',
  GET_USER_LOGIN_HISTORY_FAILURE: 'GET_USER_LOGIN_HISTORY_FAILURE',
  // -----// PUT_CLEAR_USER_PHONE_NUMBER //-----//
  PUT_CLEAR_USER_PHONE_NUMBER_START: 'PUT_CLEAR_USER_PHONE_NUMBER_START',
  PUT_CLEAR_USER_PHONE_NUMBER_SUCCESS: 'PUT_CLEAR_USER_PHONE_NUMBER_SUCCESS',
  PUT_CLEAR_USER_PHONE_NUMBER_FAILURE: 'PUT_CLEAR_USER_PHONE_NUMBER_FAILURE',
  // -----// PUT_SET_USER_PHONE_NUMBER //-----//
  PUT_SET_USER_PHONE_NUMBER_START: 'PUT_SET_USER_PHONE_NUMBER_START',
  PUT_SET_USER_PHONE_NUMBER_SUCCESS: 'PUT_SET_USER_PHONE_NUMBER_SUCCESS',
  PUT_SET_USER_PHONE_NUMBER_FAILURE: 'PUT_SET_USER_PHONE_NUMBER_FAILURE',

  /**
   * ORDERS
   */
  // -----// GET_ORDERS //-----//
  GET_ORDERS_START: 'GET_ORDERS_START',
  GET_ORDERS_SUCCESS: 'GET_ORDERS_SUCCESS',
  GET_ORDERS_FAILURE: 'GET_ORDERS_FAILURE',

  /**
   * VIDEOS
   */
  // -----// GET_VIDEOS //-----//
  GET_VIDEOS_START: 'GET_VIDEOS_START',
  GET_VIDEOS_SUCCESS: 'GET_VIDEOS_SUCCESS',
  GET_VIDEOS_FAILURE: 'GET_VIDEOS_FAILURE',
  // -----// CREATE_VIDEOS //-----//
  CREATE_VIDEOS_START: 'CREATE_VIDEOS_START',
  CREATE_VIDEOS_SUCCESS: 'CREATE_VIDEOS_SUCCESS',
  CREATE_VIDEOS_FAILURE: 'CREATE_VIDEOS_FAILURE',
  // -----// DELETE_VIDEOS //-----//
  DELETE_VIDEOS_START: 'DELETE_VIDEOS_START',
  DELETE_VIDEOS_SUCCESS: 'DELETE_VIDEOS_SUCCESS',
  DELETE_VIDEOS_FAILURE: 'DELETE_VIDEOS_FAILURE',
  // -----// UPDATE_VIDEOS //-----//
  UPDATE_VIDEOS_START: 'UPDATE_VIDEOS_START',
  UPDATE_VIDEOS_SUCCESS: 'UPDATE_VIDEOS_SUCCESS',
  UPDATE_VIDEOS_FAILURE: 'UPDATE_VIDEOS_FAILURE',

  /**
   * VACANCIES
   */
  // -----// GET_VACANCIES //-----//
  GET_VACANCIES_START: 'GET_VACANCIES_START',
  GET_VACANCIES_SUCCESS: 'GET_VACANCIES_SUCCESS',
  GET_VACANCIES_FAILURE: 'GET_VACANCIES_FAILURE',
  // -----// GET_SINGLE_VACANCY //-----//
  GET_SINGLE_VACANCY_START: 'GET_SINGLE_VACANCY_START',
  GET_SINGLE_VACANCY_SUCCESS: 'GET_SINGLE_VACANCY_SUCCESS',
  GET_SINGLE_VACANCY_FAILURE: 'GET_SINGLE_VACANCY_FAILURE',
  // -----// CREATE_VACANCIES //-----//
  CREATE_VACANCIES_START: 'CREATE_VACANCIES_START',
  CREATE_VACANCIES_SUCCESS: 'CREATE_VACANCIES_SUCCESS',
  CREATE_VACANCIES_FAILURE: 'CREATE_VACANCIES_FAILURE',
  // -----// DELETE_VACANCIES //-----//
  DELETE_VACANCIES_START: 'DELETE_VACANCIES_START',
  DELETE_VACANCIES_SUCCESS: 'DELETE_VACANCIES_SUCCESS',
  DELETE_VACANCIES_FAILURE: 'DELETE_VACANCIES_FAILURE',
  // -----// UPDATE_VACANCIES //-----//
  UPDATE_VACANCIES_START: 'UPDATE_VACANCIES_START',
  UPDATE_VACANCIES_SUCCESS: 'UPDATE_VACANCIES_SUCCESS',
  UPDATE_VACANCIES_FAILURE: 'UPDATE_VACANCIES_FAILURE',

  /**
   * POSTS
   */
  // -----// GET_POSTS //-----//
  GET_POSTS_START: 'GET_POSTS_START',
  GET_POSTS_SUCCESS: 'GET_POSTS_SUCCESS',
  GET_POSTS_FAILURE: 'GET_POSTS_FAILURE',
  // -----// GET_SINGLE_POST //-----//
  GET_SINGLE_POST_START: 'GET_SINGLE_POST_START',
  GET_SINGLE_POST_SUCCESS: 'GET_SINGLE_POST_SUCCESS',
  GET_SINGLE_POST_FAILURE: 'GET_SINGLE_POST_FAILURE',
  // -----// CREATE_POST //-----//
  CREATE_POST_START: 'CREATE_POST_START',
  CREATE_POST_SUCCESS: 'CREATE_POST_SUCCESS',
  CREATE_POST_FAILURE: 'CREATE_POST_FAILURE',
  // -----// UPDATE_POST //-----//
  UPDATE_POST_START: 'UPDATE_POST_START',
  UPDATE_POST_SUCCESS: 'UPDATE_POST_SUCCESS',
  UPDATE_POST_FAILURE: 'UPDATE_POST_FAILURE',
  // -----// DELETE_POST //-----//
  DELETE_POST_START: 'DELETE_POST_START',
  DELETE_POST_SUCCESS: 'DELETE_POST_SUCCESS',
  DELETE_POST_FAILURE: 'DELETE_POST_FAILURE',
  // -----// CREATE_POST_CONTENT //-----//
  CREATE_POST_CONTENT_START: 'CREATE_POST_CONTENT_START',
  CREATE_POST_CONTENT_SUCCESS: 'CREATE_POST_CONTENT_SUCCESS',
  CREATE_POST_CONTENT_FAILURE: 'CREATE_POST_CONTENT_FAILURE',
  // -----// UPDATE_POST_CONTENT //-----//
  UPDATE_POST_CONTENT_START: 'UPDATE_POST_CONTENT_START',
  UPDATE_POST_CONTENT_SUCCESS: 'UPDATE_POST_CONTENT_SUCCESS',
  UPDATE_POST_CONTENT_FAILURE: 'UPDATE_POST_CONTENT_FAILURE',
  // -----// DELETE_POST_CONTENT //-----//
  DELETE_POST_CONTENT_START: 'DELETE_POST_CONTENT_START',
  DELETE_POST_CONTENT_SUCCESS: 'DELETE_POST_CONTENT_SUCCESS',
  DELETE_POST_CONTENT_FAILURE: 'DELETE_POST_CONTENT_FAILURE',
  // -----// GET_CATEGORIES //-----//
  GET_CATEGORIES_START: 'GET_CATEGORIES_START',
  GET_CATEGORIES_SUCCESS: 'GET_CATEGORIES_SUCCESS',
  GET_CATEGORIES_FAILURE: 'GET_CATEGORIES_FAILURE',
  // -----// GET_SINGLE_CATEGORY //-----//
  GET_SINGLE_CATEGORY_START: 'GET_SINGLE_CATEGORY_START',
  GET_SINGLE_CATEGORY_SUCCESS: 'GET_SINGLE_CATEGORY_SUCCESS',
  GET_SINGLE_CATEGORY_FAILURE: 'GET_SINGLE_CATEGORY_FAILURE',
  // -----// CREATE_CATEGORY //-----//
  CREATE_CATEGORY_START: 'CREATE_CATEGORY_START',
  CREATE_CATEGORY_SUCCESS: 'CREATE_CATEGORY_SUCCESS',
  CREATE_CATEGORY_FAILURE: 'CREATE_CATEGORY_FAILURE',
  // -----// DELETE_CATEGORY //-----//
  DELETE_CATEGORY_START: 'DELETE_CATEGORY_START',
  DELETE_CATEGORY_SUCCESS: 'DELETE_CATEGORY_SUCCESS',
  DELETE_CATEGORY_FAILURE: 'DELETE_CATEGORY_FAILURE',
  // -----// UPDATE_CATEGORY //-----//
  UPDATE_CATEGORY_START: 'UPDATE_CATEGORY_START',
  UPDATE_CATEGORY_SUCCESS: 'UPDATE_CATEGORY_SUCCESS',
  UPDATE_CATEGORY_FAILURE: 'UPDATE_CATEGORY_FAILURE',
  // -----// CREATE_CATEGORY_CONTENT //-----//
  CREATE_CATEGORY_CONTENT_START: 'CREATE_CATEGORY_CONTENT_START',
  CREATE_CATEGORY_CONTENT_SUCCESS: 'CREATE_CATEGORY_CONTENT_SUCCESS',
  CREATE_CATEGORY_CONTENT_FAILURE: 'CREATE_CATEGORY_CONTENT_FAILURE',
  // -----// UPDATE_CATEGORY_CONTENT //-----//
  UPDATE_CATEGORY_CONTENT_START: 'UPDATE_CATEGORY_CONTENT_START',
  UPDATE_CATEGORY_CONTENT_SUCCESS: 'UPDATE_CATEGORY_CONTENT_SUCCESS',
  UPDATE_CATEGORY_CONTENT_FAILURE: 'UPDATE_CATEGORY_CONTENT_FAILURE',
  // -----// DELETE_CATEGORY_CONTENT //-----//
  DELETE_CATEGORY_CONTENT_START: 'DELETE_CATEGORY_CONTENT_START',
  DELETE_CATEGORY_CONTENT_SUCCESS: 'DELETE_CATEGORY_CONTENT_SUCCESS',
  DELETE_CATEGORY_CONTENT_FAILURE: 'DELETE_CATEGORY_CONTENT_FAILURE',

  /**
   * VOTE
   */
  // -----// GET_VOTE_PROJECTS //-----//
  GET_VOTE_PROJECTS_START: 'GET_VOTE_PROJECTS_START',
  GET_VOTE_PROJECTS_SUCCESS: 'GET_VOTE_PROJECTS_SUCCESS',
  GET_VOTE_PROJECTS_FAILURE: 'GET_VOTE_PROJECTS_FAILURE',
  // -----// GET_SINGLE_VOTE_PROJECT //-----//
  GET_SINGLE_VOTE_PROJECT_START: 'GET_SINGLE_VOTE_PROJECT_START',
  GET_SINGLE_VOTE_PROJECT_SUCCESS: 'GET_SINGLE_VOTE_PROJECT_SUCCESS',
  GET_SINGLE_VOTE_PROJECT_FAILURE: 'GET_SINGLE_VOTE_PROJECT_FAILURE',
  // -----// CREATE_VOTE_PROJECT //-----//
  POST_CREATE_VOTE_PROJECT_START: 'POST_CREATE_VOTE_PROJECT_START',
  POST_CREATE_VOTE_PROJECT_SUCCESS: 'POST_CREATE_VOTE_PROJECT_SUCCESS',
  POST_CREATE_VOTE_PROJECT_FAILURE: 'POST_CREATE_VOTE_PROJECT_FAILURE',
  // -----// UPDATE_VOTE_PROJECT //-----//
  UPDATE_VOTE_PROJECT_START: 'UPDATE_VOTE_PROJECT_START',
  UPDATE_VOTE_PROJECT_SUCCESS: 'UPDATE_VOTE_PROJECT_SUCCESS',
  UPDATE_VOTE_PROJECT_FAILURE: 'UPDATE_VOTE_PROJECT_FAILURE',
  // -----// DELETE_VOTE_PROJECT //-----//
  DELETE_VOTE_PROJECT_START: 'DELETE_VOTE_PROJECT_START',
  DELETE_VOTE_PROJECT_SUCCESS: 'DELETE_VOTE_PROJECT_SUCCESS',
  DELETE_VOTE_PROJECT_FAILURE: 'DELETE_VOTE_PROJECT_FAILURE',
  // -----// CREATE_VOTE_PROJECT_CONTENT //-----//
  CREATE_VOTE_PROJECT_CONTENT_START: 'CREATE_VOTE_PROJECT_CONTENT_START',
  CREATE_VOTE_PROJECT_CONTENT_SUCCESS: 'CREATE_VOTE_PROJECT_CONTENT_SUCCESS',
  CREATE_VOTE_PROJECT_CONTENT_FAILURE: 'CREATE_VOTE_PROJECT_CONTENT_FAILURE',
  // -----// UPDATE_VOTE_PROJECT_CONTENT //-----//
  UPDATE_VOTE_PROJECT_CONTENT_START: 'UPDATE_VOTE_PROJECT_CONTENT_START',
  UPDATE_VOTE_PROJECT_CONTENT_SUCCESS: 'UPDATE_VOTE_PROJECT_CONTENT_SUCCESS',
  UPDATE_VOTE_PROJECT_CONTENT_FAILURE: 'UPDATE_VOTE_PROJECT_CONTENT_FAILURE',
  // -----// DELETE_VOTE_PROJECT_CONTENT //-----//
  DELETE_VOTE_PROJECT_CONTENT_START: 'DELETE_VOTE_PROJECT_CONTENT_START',
  DELETE_VOTE_PROJECT_CONTENT_SUCCESS: 'DELETE_VOTE_PROJECT_CONTENT_SUCCESS',
  DELETE_VOTE_PROJECT_CONTENT_FAILURE: 'DELETE_VOTE_PROJECT_CONTENT_FAILURE',
  // -----// PUT_VOTE_PROJECT_PUBLISHED //-----//
  PUT_VOTE_PROJECT_PUBLISHED_START: 'PUT_VOTE_PROJECT_PUBLISHED_START',
  PUT_VOTE_PROJECT_PUBLISHED_SUCCESS: 'PUT_VOTE_PROJECT_PUBLISHED_SUCCESS',
  PUT_VOTE_PROJECT_PUBLISHED_FAILURE: 'PUT_VOTE_PROJECT_PUBLISHED_FAILURE',

  // -----// GET_PROJECT_BALANCE //-----//
  GET_PROJECT_BALANCE_START: 'GET_PROJECT_BALANCE_START',
  GET_PROJECT_BALANCE_SUCCESS: 'GET_PROJECT_BALANCE_SUCCESS',
  GET_PROJECT_BALANCE_FAILURE: 'GET_PROJECT_BALANCE_FAILURE',
  // -----// PUT_PROJECT_BALANCE //-----//
  PUT_PROJECT_BALANCE_START: 'PUT_PROJECT_BALANCE_START',
  PUT_PROJECT_BALANCE_SUCCESS: 'PUT_PROJECT_BALANCE_SUCCESS',
  PUT_PROJECT_BALANCE_FAILURE: 'PUT_PROJECT_BALANCE_FAILURE',

  /**
   * TRADER INFO
   */
  // -----// GET_TRADER_INFO //-----//
  GET_TRADER_INFO_START: 'GET_TRADER_INFO_START',
  GET_TRADER_INFO_SUCCESS: 'GET_TRADER_INFO_SUCCESS',
  GET_TRADER_INFO_FAILURE: 'GET_TRADER_INFO_FAILURE',
  // -----// UPDATE_TRADER_INFO //-----//
  UPDATE_TRADER_INFO_START: 'UPDATE_TRADER_INFO_START',
  UPDATE_TRADER_INFO_SUCCESS: 'UPDATE_TRADER_INFO_SUCCESS',
  UPDATE_TRADER_INFO_FAILURE: 'UPDATE_TRADER_INFO_FAILURE',

  /**
   * MARKETS
   */
  // -----// GET_PAIRS //-----//
  GET_PAIRS_START: 'GET_PAIRS_START',
  GET_PAIRS_SUCCESS: 'GET_PAIRS_SUCCESS',
  GET_PAIRS_FAILURE: 'GET_PAIRS_FAILURE',
  // -----// POST_PAIRS //-----//
  POST_PAIRS_START: 'POST_PAIRS_START',
  POST_PAIRS_SUCCESS: 'POST_PAIRS_SUCCESS',
  POST_PAIRS_FAILURE: 'POST_PAIRS_FAILURE',
  // -----// UPDATE_PAIRS //-----//
  UPDATE_PAIRS_START: 'UPDATE_PAIRS_START',
  UPDATE_PAIRS_SUCCESS: 'UPDATE_PAIRS_SUCCESS',
  UPDATE_PAIRS_FAILURE: 'UPDATE_PAIRS_FAILURE',
  // -----// UPDATE_TOP_PAIRS //-----//
  UPDATE_TOP_PAIRS_START: 'UPDATE_TOP_PAIRS_START',
  UPDATE_TOP_PAIRS_SUCCESS: 'UPDATE_TOP_PAIRS_SUCCESS',
  UPDATE_TOP_PAIRS_FAILURE: 'UPDATE_TOP_PAIRS_FAILURE',
  // -----// GET_TOKENS //-----//
  GET_TOKENS_START: 'GET_TOKENS_START',
  GET_TOKENS_SUCCESS: 'GET_TOKENS_SUCCESS',
  GET_TOKENS_FAILURE: 'GET_TOKENS_FAILURE',
  // -----// POST_TOKEN //-----//
  POST_TOKEN_START: 'POST_TOKEN_START',
  POST_TOKEN_SUCCESS: 'POST_TOKEN_SUCCESS',
  POST_TOKEN_FAILURE: 'POST_TOKEN_FAILURE',
  // -----// GET_LIMITATIONS //-----//
  GET_LIMITATIONS_START: 'GET_LIMITATIONS_START',
  GET_LIMITATIONS_SUCCESS: 'GET_LIMITATIONS_SUCCESS',
  GET_LIMITATIONS_FAILURE: 'GET_LIMITATIONS_FAILURE',
  // -----// UPDATE_LIMITATIONS //-----//
  UPDATE_LIMITATIONS_START: 'UPDATE_LIMITATIONS_START',
  UPDATE_LIMITATIONS_SUCCESS: 'UPDATE_LIMITATIONS_SUCCESS',
  UPDATE_LIMITATIONS_FAILURE: 'UPDATE_LIMITATIONS_FAILURE',
  // -----// GET_FEES //-----//
  GET_FEES_START: 'GET_FEES_START',
  GET_FEES_SUCCESS: 'GET_FEES_SUCCESS',
  GET_FEES_FAILURE: 'GET_FEES_FAILURE',
  // -----// UPDATE_FEES //-----//
  UPDATE_FEES_START: 'UPDATE_FEES_START',
  UPDATE_FEES_SUCCESS: 'UPDATE_FEES_SUCCESS',
  UPDATE_FEES_FAILURE: 'UPDATE_FEES_FAILURE',
  // -----// GET_CURRENCIES //-----//
  GET_CURRENCIES_START: 'GET_CURRENCIES_START',
  GET_CURRENCIES_SUCCESS: 'GET_CURRENCIES_SUCCESS',
  GET_CURRENCIES_FAILURE: 'GET_CURRENCIES_FAILURE',
  // -----// UPDATE_CURRENCIES //-----//
  UPDATE_CURRENCIES_START: 'UPDATE_CURRENCIES_START',
  UPDATE_CURRENCIES_SUCCESS: 'UPDATE_CURRENCIES_SUCCESS',
  UPDATE_CURRENCIES_FAILURE: 'UPDATE_CURRENCIES_FAILURE',
  // -----// GET_MARKET_MAKER //-----//
  GET_MARKET_MAKER_START: 'GET_MARKET_MAKER_START',
  GET_MARKET_MAKER_SUCCESS: 'GET_MARKET_MAKER_SUCCESS',
  GET_MARKET_MAKER_FAILURE: 'GET_MARKET_MAKER_FAILURE',
  // -----// PUT_MARKET_MAKER //-----//
  PUT_MARKET_MAKER_START: 'PUT_MARKET_MAKER_START',
  PUT_MARKET_MAKER_SUCCESS: 'PUT_MARKET_MAKER_SUCCESS',
  PUT_MARKET_MAKER_FAILURE: 'PUT_MARKET_MAKER_FAILURE',
  // -----// PUT_TOGGLE_ENABLED //-----//
  PUT_TOGGLE_ENABLED_START: 'PUT_TOGGLE_ENABLED_START',
  PUT_TOGGLE_ENABLED_SUCCESS: 'PUT_TOGGLE_ENABLED_SUCCESS',
  PUT_TOGGLE_ENABLED_FAILURE: 'PUT_TOGGLE_ENABLED_FAILURE',
  // -----// PUT_TOGGLE_VERSION_BOTS_ENABLED //-----//
  PUT_TOGGLE_VERSION_BOTS_ENABLED_START: 'PUT_TOGGLE_VERSION_BOTS_ENABLED_START',
  PUT_TOGGLE_VERSION_BOTS_ENABLED_SUCCESS: 'PUT_TOGGLE_VERSION_BOTS_ENABLED_SUCCESS',
  PUT_TOGGLE_VERSION_BOTS_ENABLED_FAILURE: 'PUT_TOGGLE_VERSION_BOTS_ENABLED_FAILURE',
  // -----// GET_MARKET_VOLUME_RATES //-----//
  GET_MARKET_VOLUME_RATES_START: 'GET_MARKET_VOLUME_RATES_START',
  GET_MARKET_VOLUME_RATES_SUCCESS: 'GET_MARKET_VOLUME_RATES_SUCCESS',
  GET_MARKET_VOLUME_RATES_FAILURE: 'GET_MARKET_VOLUME_RATES_FAILURE',
  // -----// UPDATE_MARKET_VOLUME_RATE //-----//
  UPDATE_MARKET_VOLUME_RATE_START: 'UPDATE_MARKET_VOLUME_RATE_START',
  UPDATE_MARKET_VOLUME_RATE_SUCCESS: 'UPDATE_MARKET_VOLUME_RATE_SUCCESS',
  UPDATE_MARKET_VOLUME_RATE_FAILURE: 'UPDATE_MARKET_VOLUME_RATE_FAILURE',
  // -----// UPDATE_MARKET_VOLUME_LIMITS //-----//
  UPDATE_MARKET_VOLUME_LIMITS_START: 'UPDATE_MARKET_VOLUME_LIMITS_START',
  UPDATE_MARKET_VOLUME_LIMITS_SUCCESS: 'UPDATE_MARKET_VOLUME_LIMITS_SUCCESS',
  UPDATE_MARKET_VOLUME_LIMITS_FAILURE: 'UPDATE_MARKET_VOLUME_LIMITS_FAILURE',

  /**
   * Fiat TRANSFER
   */
  // -----// GET_FIAT_DEPOSITS //-----//
  GET_FIAT_DEPOSITS_START: 'GET_FIAT_DEPOSITS_START',
  GET_FIAT_DEPOSITS_SUCCESS: 'GET_FIAT_DEPOSITS_SUCCESS',
  GET_FIAT_DEPOSITS_FAILURE: 'GET_FIAT_DEPOSITS_FAILURE',

  // -----// GET_FIAT_PENDING //-----//
  GET_FIAT_PENDING_START: 'GET_FIAT_PENDING_START',
  GET_FIAT_PENDING_SUCCESS: 'GET_FIAT_PENDING_SUCCESS',
  GET_FIAT_PENDING_FAILURE: 'GET_FIAT_PENDING_FAILURE',

  // -----// APPROVE_FIAT_PENDING //-----//
  APPROVE_FIAT_PENDING_START: 'APPROVE_FIAT_PENDING_START',
  APPROVE_FIAT_PENDING_SUCCESS: 'APPROVE_FIAT_PENDING_SUCCESS',
  APPROVE_FIAT_PENDING_FAILURE: 'APPROVE_FIAT_PENDING_FAILURE',

  // -----// REJECT_FIAT_PENDING //-----//
  REJECT_FIAT_PENDING_START: 'REJECT_FIAT_PENDING_START',
  REJECT_FIAT_PENDING_SUCCESS: 'REJECT_FIAT_PENDING_SUCCESS',
  REJECT_FIAT_PENDING_FAILURE: 'REJECT_FIAT_PENDING_FAILURE',

  // -----// GET_FIAT_WITHDRAWALS //-----//
  GET_FIAT_WITHDRAWALS_START: 'GET_FIAT_WITHDRAWALS_START',
  GET_FIAT_WITHDRAWALS_SUCCESS: 'GET_FIAT_WITHDRAWALS_SUCCESS',
  GET_FIAT_WITHDRAWALS_FAILURE: 'GET_FIAT_WITHDRAWALS_FAILURE',

  /**
   * CRYPTO TRANSFER
   */
  // -----// GET_DEPOSITS //-----//
  GET_DEPOSITS_START: 'GET_DEPOSITS_START',
  GET_DEPOSITS_SUCCESS: 'GET_DEPOSITS_SUCCESS',
  GET_DEPOSITS_FAILURE: 'GET_DEPOSITS_FAILURE',
  // -----// GET_PENDING //-----//
  GET_PENDING_START: 'GET_PENDING_START',
  GET_PENDING_SUCCESS: 'GET_PENDING_SUCCESS',
  GET_PENDING_FAILURE: 'GET_PENDING_FAILURE',
  // -----// APPROVE_PENDING //-----//
  APPROVE_PENDING_START: 'APPROVE_PENDING_START',
  APPROVE_PENDING_SUCCESS: 'APPROVE_PENDING_SUCCESS',
  APPROVE_PENDING_FAILURE: 'APPROVE_PENDING_FAILURE',
  // -----// REJECT_PENDING //-----//
  REJECT_PENDING_START: 'REJECT_PENDING_START',
  REJECT_PENDING_SUCCESS: 'REJECT_PENDING_SUCCESS',
  REJECT_PENDING_FAILURE: 'REJECT_PENDING_FAILURE',
  // -----// GET_WITHDRAWALS //-----//
  GET_WITHDRAWALS_START: 'GET_WITHDRAWALS_START',
  GET_WITHDRAWALS_SUCCESS: 'GET_WITHDRAWALS_SUCCESS',
  GET_WITHDRAWALS_FAILURE: 'GET_WITHDRAWALS_FAILURE',

  /**
   * WALLETS
   */

  // -----// GET_HOT_WALLETS //-----//
  GET_HOT_WALLETS_START: 'GET_HOT_WALLETS_START',
  GET_HOT_WALLETS_SUCCESS: 'GET_HOT_WALLETS_SUCCESS',
  GET_HOT_WALLETS_FAILURE: 'GET_HOT_WALLETS_FAILURE',
  // -----// UPDATE_HOT_WALLETS //-----//
  UPDATE_HOT_WALLETS_START: 'UPDATE_HOT_WALLETS_START',
  UPDATE_HOT_WALLETS_SUCCESS: 'UPDATE_HOT_WALLETS_SUCCESS',
  UPDATE_HOT_WALLETS_FAILURE: 'UPDATE_HOT_WALLETS_FAILURE',
  // -----// GET_WALLET_ADDRES //-----//
  GET_WALLET_ADDRES_START: 'GET_WALLET_ADDRES_START',
  GET_WALLET_ADDRES_SUCCESS: 'GET_WALLET_ADDRES_SUCCESS',
  GET_WALLET_ADDRES_FAILURE: 'GET_WALLET_ADDRES_FAILURE',
  // -----// TRANSFER_TO_COLD //-----//
  TRANSFER_TO_COLD_START: 'TRANSFER_TO_COLD_START',
  TRANSFER_TO_COLD_SUCCESS: 'TRANSFER_TO_COLD_SUCCESS',
  TRANSFER_TO_COLD_FAILURE: 'TRANSFER_TO_COLD_FAILURE',
  // -----// GET_PROFIT //-----//
  GET_PROFIT_START: 'GET_PROFIT_START',
  GET_PROFIT_SUCCESS: 'GET_PROFIT_SUCCESS',
  GET_PROFIT_FAILURE: 'GET_PROFIT_FAILURE',
  // -----// GET_WALLET_TRANSACTIONS //-----//
  GET_WALLET_TRANSACTIONS_START: 'GET_WALLET_TRANSACTIONS_START',
  GET_WALLET_TRANSACTIONS_SUCCESS: 'GET_WALLET_TRANSACTIONS_SUCCESS',
  GET_WALLET_TRANSACTIONS_FAILURE: 'GET_WALLET_TRANSACTIONS_FAILURE',
  // -----// GET_BNIX_FEE //-----//
  GET_BNIX_FEE_START: 'GET_BNIX_FEE_START',
  GET_BNIX_FEE_SUCCESS: 'GET_BNIX_FEE_SUCCESS',
  GET_BNIX_FEE_FAILURE: 'GET_BNIX_FEE_FAILURE',
  // -----// UPDATE_BNIX_FEE //-----//
  UPDATE_BNIX_FEE_START: 'UPDATE_BNIX_FEE_START',
  UPDATE_BNIX_FEE_SUCCESS: 'UPDATE_BNIX_FEE_SUCCESS',
  UPDATE_BNIX_FEE_FAILURE: 'UPDATE_BNIX_FEE_FAILURE',
  // -----// GET_GAS_FEE_SETTINGS //-----//
  GET_GAS_FEE_SETTINGS_START: 'GET_GAS_FEE_SETTINGS_START',
  GET_GAS_FEE_SETTINGS_SUCCESS: 'GET_GAS_FEE_SETTINGS_SUCCESS',
  GET_GAS_FEE_SETTINGS_FAILURE: 'GET_GAS_FEE_SETTINGS_FAILURE',
  // -----// UPDATE_GAS_FEE_SETTINGS //-----//
  UPDATE_GAS_FEE_SETTINGS_START: 'UPDATE_GAS_FEE_SETTINGS_START',
  UPDATE_GAS_FEE_SETTINGS_SUCCESS: 'UPDATE_GAS_FEE_SETTINGS_SUCCESS',
  UPDATE_GAS_FEE_SETTINGS_FAILURE: 'UPDATE_GAS_FEE_SETTINGS_FAILURE',
  // -----// GET_CURRENT_GAS_PRICE //-----//
  GET_CURRENT_GAS_PRICE_START: 'GET_CURRENT_GAS_PRICE_START',
  GET_CURRENT_GAS_PRICE_SUCCESS: 'GET_CURRENT_GAS_PRICE_SUCCESS',
  GET_CURRENT_GAS_PRICE_FAILURE: 'GET_CURRENT_GAS_PRICE_FAILURE',

  /**
   * REFERRALS
   */
  // -----// GET_REFERRALS //-----//
  GET_REFERRALS_START: 'GET_REFERRALS_START',
  GET_REFERRALS_SUCCESS: 'GET_REFERRALS_SUCCESS',
  GET_REFERRALS_FAILURE: 'GET_REFERRALS_FAILURE',
  // -----// GET_REFERRALS_EXCEL //-----//
  GET_REFERRALS_EXCEL_START: 'GET_REFERRALS_EXCEL_START',
  GET_REFERRALS_EXCEL_SUCCESS: 'GET_REFERRALS_EXCEL_SUCCESS',
  GET_REFERRALS_EXCEL_FAILURE: 'GET_REFERRALS_EXCEL_FAILURE',
  // -----// GET_REFERRALS_XML //-----//
  GET_REFERRALS_XML_START: 'GET_REFERRALS_XML_START',
  GET_REFERRALS_XML_SUCCESS: 'GET_REFERRALS_XML_SUCCESS',
  GET_REFERRALS_XML_FAILURE: 'GET_REFERRALS_XML_FAILURE',
  // -----// GET_REFERRALS_STATISTICS //-----//
  GET_REFERRALS_STATISTICS_START: 'GET_REFERRALS_STATISTICS_START',
  GET_REFERRALS_STATISTICS_SUCCESS: 'GET_REFERRALS_STATISTICS_SUCCESS',
  GET_REFERRALS_STATISTICS_FAILURE: 'GET_REFERRALS_STATISTICS_FAILURE',
  // -----// GET_USER_LIST_OF_REFERRALS //-----//
  GET_USER_LIST_OF_REFERRALS_START: 'GET_USER_LIST_OF_REFERRALS_START',
  GET_USER_LIST_OF_REFERRALS_SUCCESS: 'GET_USER_LIST_OF_REFERRALS_SUCCESS',
  GET_USER_LIST_OF_REFERRALS_FAILURE: 'GET_USER_LIST_OF_REFERRALS_FAILURE',
  // -----// GET_USER_REFERRALS_BONUSES //-----//
  GET_USER_REFERRALS_BONUSES_START: 'GET_USER_REFERRALS_BONUSES_START',
  GET_USER_REFERRALS_BONUSES_SUCCESS: 'GET_USER_REFERRALS_BONUSES_SUCCESS',
  GET_USER_REFERRALS_BONUSES_FAILURE: 'GET_USER_REFERRALS_BONUSES_FAILURE',

  /**
   * ADMINS
   */
  // -----// GET_ADMINS //-----//
  GET_ADMINS_START: 'GET_ADMINS_START',
  GET_ADMINS_SUCCESS: 'GET_ADMINS_SUCCESS',
  GET_ADMINS_FAILURE: 'GET_ADMINS_FAILURE',
  // -----// GET_PERMISSIONS //-----//
  GET_PERMISSIONS_START: 'GET_PERMISSIONS_START',
  GET_PERMISSIONS_SUCCESS: 'GET_PERMISSIONS_SUCCESS',
  GET_PERMISSIONS_FAILURE: 'GET_PERMISSIONS_FAILURE',
  // -----// POST_ADMIN //-----//
  POST_ADMIN_START: 'POST_ADMIN_START',
  POST_ADMIN_SUCCESS: 'POST_ADMIN_SUCCESS',
  POST_ADMIN_FAILURE: 'POST_ADMIN_FAILURE',
  // -----// PUT_ADMIN //-----//
  PUT_ADMIN_START: 'PUT_ADMIN_START',
  PUT_ADMIN_SUCCESS: 'PUT_ADMIN_SUCCESS',
  PUT_ADMIN_FAILURE: 'PUT_ADMIN_FAILURE',
  // -----// DELETE_ADMIN //-----//
  DELETE_ADMIN_START: 'DELETE_ADMIN_START',
  DELETE_ADMIN_SUCCESS: 'DELETE_ADMIN_SUCCESS',
  DELETE_ADMIN_FAILURE: 'DELETE_ADMIN_FAILURE',

  /**
   * SETTINGS
   */
  // -----// UPDATE_PASSWORD //-----//
  UPDATE_PASSWORD_START: 'UPDATE_PASSWORD_START',
  UPDATE_PASSWORD_SUCCESS: 'UPDATE_PASSWORD_SUCCESS',
  UPDATE_PASSWORD_FAILURE: 'UPDATE_PASSWORD_FAILURE',
  // -----// GET_SECRET_KEY //-----//
  GET_SECRET_KEY_START: 'GET_SECRET_KEY_START',
  GET_SECRET_KEY_SUCCESS: 'GET_SECRET_KEY_SUCCESS',
  GET_SECRET_KEY_FAILURE: 'GET_SECRET_KEY_FAILURE',
  // -----// ENABLE_2FA //-----//
  ENABLE_2FA_START: 'ENABLE_2FA_START',
  ENABLE_2FA_SUCCESS: 'ENABLE_2FA_SUCCESS',
  ENABLE_2FA_FAILURE: 'ENABLE_2FA_FAILURE',
  // -----// DISABLE_2FA //-----//
  DISABLE_2FA_START: 'DISABLE_2FA_START',
  DISABLE_2FA_SUCCESS: 'DISABLE_2FA_SUCCESS',
  DISABLE_2FA_FAILURE: 'DISABLE_2FA_FAILURE',
  // -----// GET_ACCOUNT //-----//
  GET_ACCOUNT_START: 'GET_ACCOUNT_START',
  GET_ACCOUNT_SUCCESS: 'GET_ACCOUNT_SUCCESS',
  GET_ACCOUNT_FAILURE: 'GET_ACCOUNT_FAILURE',
  // -----// PUT_ACCOUNT //-----//
  PUT_ACCOUNT_START: 'PUT_ACCOUNT_START',
  PUT_ACCOUNT_SUCCESS: 'PUT_ACCOUNT_SUCCESS',
  PUT_ACCOUNT_FAILURE: 'PUT_ACCOUNT_FAILURE',
  // -----// GET_BOT_URL //-----//
  GET_BOT_URL_START: 'GET_BOT_URL_START',
  GET_BOT_URL_SUCCESS: 'GET_BOT_URL_SUCCESS',
  GET_BOT_URL_FAILURE: 'GET_BOT_URL_FAILURE',
  // -----// UPDATE_ADMIN_CHAT_ID //-----//
  UPDATE_ADMIN_CHAT_ID_START: 'UPDATE_ADMIN_CHAT_ID_START',
  UPDATE_ADMIN_CHAT_ID_SUCCESS: 'UPDATE_ADMIN_CHAT_ID_SUCCESS',
  UPDATE_ADMIN_CHAT_ID_FAILURE: 'UPDATE_ADMIN_CHAT_ID_FAILURE',
  /**
   * 2FA
   */
  // -----// GET_RESET_2FA_MESSAGE //-----//
  GET_RESET_2FA_MESSAGE_START: 'GET_RESET_2FA_MESSAGE_START',
  GET_RESET_2FA_MESSAGE_SUCCESS: 'GET_RESET_2FA_MESSAGE_SUCCESS',
  GET_RESET_2FA_MESSAGE_FAILURE: 'GET_RESET_2FA_MESSAGE_FAILURE',
  // -----// APPROVE_2FA //-----//
  APPROVE_2FA_START: 'APPROVE_2FA',
  APPROVE_2FA_SUCCESS: 'APPROVE_2FA_SUCCESS',
  APPROVE_2FA_FAILURE: 'APPROVE_2FA_FAILURE',
  // -----// REJECT_2FA //-----//
  REJECT_2FA_START: 'REJECT_2FA_START',
  REJECT_2FA_SUCCESS: 'REJECT_2FA_SUCCESS',
  REJECT_2FA_FAILURE: 'REJECT_2FA_FAILURE',

  /**
   * CASHBACK
   */
  // -----// GET_CASHBACKS //-----//
  GET_CASHBACKS_START: 'GET_CASHBACKS_START',
  GET_CASHBACKS_SUCCESS: 'GET_CASHBACKS_SUCCESS',
  GET_CASHBACKS_FAILURE: 'GET_CASHBACKS_FAILURE',
  // -----// POST_CREATE_CASHBACK //-----//
  POST_CREATE_CASHBACK_START: 'POST_CREATE_CASHBACK_START',
  POST_CREATE_CASHBACK_SUCCESS: 'POST_CREATE_CASHBACK_SUCCESS',
  POST_CREATE_CASHBACK_FAILURE: 'POST_CREATE_CASHBACK_FAILURE',
  // -----// PUT_CASHBACK //-----//
  PUT_CASHBACK_START: 'PUT_CASHBACK_START',
  PUT_CASHBACK_SUCCESS: 'PUT_CASHBACK_SUCCESS',
  PUT_CASHBACK_FAILURE: 'PUT_CASHBACK_FAILURE',
  // -----// DELETE_CASHBACK //-----//
  DELETE_CASHBACK_START: 'DELETE_CASHBACK_START',
  DELETE_CASHBACK_SUCCESS: 'DELETE_CASHBACK_SUCCESS',
  DELETE_CASHBACK_FAILURE: 'DELETE_CASHBACK_FAILURE',

  // -----// GET_USERS_CASHBACKS //-----//
  GET_USERS_CASHBACKS_START: 'GET_USERS_CASHBACKS_START',
  GET_USERS_CASHBACKS_SUCCESS: 'GET_USERS_CASHBACKS_SUCCESS',
  GET_USERS_CASHBACKS_FAILURE: 'GET_USERS_CASHBACKS_FAILURE',

  /**
   * FEES_AND_LIMITS
   */
  // -----// GET_FEES_AND_LIMITS //-----//
  GET_FEES_AND_LIMITS_START: 'GET_FEES_AND_LIMITS_START',
  GET_FEES_AND_LIMITS_SUCCESS: 'GET_FEES_AND_LIMITS_SUCCESS',
  GET_FEES_AND_LIMITS_FAILURE: 'GET_FEES_AND_LIMITS_FAILURE',
  // -----// PUT_FEES_AND_LIMITS //-----//
  PUT_FEES_AND_LIMITS_START: 'PUT_FEES_AND_LIMITS_START',
  PUT_FEES_AND_LIMITS_SUCCESS: 'PUT_FEES_AND_LIMITS_SUCCESS',
  PUT_FEES_AND_LIMITS_FAILURE: 'PUT_FEES_AND_LIMITS_FAILURE',

  /**
   * TRADES
   */
  // -----// GET_TRADES //-----//
  GET_TRADES_START: 'GET_TRADES_START',
  GET_TRADES_SUCCESS: 'GET_TRADES_SUCCESS',
  GET_TRADES_FAILURE: 'GET_TRADES_FAILURE',

  /**
   * TRADE_VOLUME_SETTINGS
   */
  // -----// GET_TRADE_VOLUME_SETTINGS //-----//
  GET_TRADE_VOLUME_SETTINGS_START: 'GET_TRADE_VOLUME_SETTINGS_START',
  GET_TRADE_VOLUME_SETTINGS_SUCCESS: 'GET_TRADE_VOLUME_SETTINGS_SUCCESS',
  GET_TRADE_VOLUME_SETTINGS_FAILURE: 'GET_TRADE_VOLUME_SETTINGS_FAILURE',
  // -----// PUT_TRADE_VOLUME_SETTINGS //-----//
  PUT_TRADE_VOLUME_SETTINGS_START: 'PUT_TRADE_VOLUME_SETTINGS_START',
  PUT_TRADE_VOLUME_SETTINGS_SUCCESS: 'PUT_TRADE_VOLUME_SETTINGS_SUCCESS',
  PUT_TRADE_VOLUME_SETTINGS_FAILURE: 'PUT_TRADE_VOLUME_SETTINGS_FAILURE',

  /**
   * CHAT_MODERATORS
   */
  // -----// GET_CHAT_MODERATORS //-----//
  GET_CHAT_MODERATORS_START: 'GET_CHAT_MODERATORS_START',
  GET_CHAT_MODERATORS_SUCCESS: 'GET_CHAT_MODERATORS_SUCCESS',
  GET_CHAT_MODERATORS_FAILURE: 'GET_CHAT_MODERATORS_FAILURE',
  // -----// POST_CHAT_MODERATOR //-----//
  POST_CHAT_MODERATOR_START: 'POST_CHAT_MODERATOR_START',
  POST_CHAT_MODERATOR_SUCCESS: 'POST_CHAT_MODERATOR_SUCCESS',
  POST_CHAT_MODERATOR_FAILURE: 'POST_CHAT_MODERATOR_FAILURE',
  // -----// PUT_CHAT_MODERATOR_ROLE //-----//
  PUT_CHAT_MODERATOR_ROLE_START: 'PUT_CHAT_MODERATOR_ROLE_START',
  PUT_CHAT_MODERATOR_ROLE_SUCCESS: 'PUT_CHAT_MODERATOR_ROLE_SUCCESS',
  PUT_CHAT_MODERATOR_ROLE_FAILURE: 'PUT_CHAT_MODERATOR_ROLE_FAILURE',

  /**
   * USER_SECURITY
   */
  // -----// GET_USER_SECURITY_OPTIONS //-----//
  GET_USER_SECURITY_OPTIONS_START: 'GET_USER_SECURITY_OPTIONS_START',
  GET_USER_SECURITY_OPTIONS_SUCCESS: 'GET_USER_SECURITY_OPTIONS_SUCCESS',
  GET_USER_SECURITY_OPTIONS_FAILURE: 'GET_USER_SECURITY_OPTIONS_FAILURE',
  // -----// PUT_USER_SECURITY_OPTIONS //-----//
  PUT_USER_SECURITY_OPTIONS_START: 'PUT_USER_SECURITY_OPTIONS_START',
  PUT_USER_SECURITY_OPTIONS_SUCCESS: 'PUT_USER_SECURITY_OPTIONS_SUCCESS',
  PUT_USER_SECURITY_OPTIONS_FAILURE: 'PUT_USER_SECURITY_OPTIONS_FAILURE',
  // -----// RESET_WITHDRAWAL_SECRET_PHRASE //-----//
  RESET_WITHDRAWAL_SECRET_PHRASE_START: 'RESET_WITHDRAWAL_SECRET_PHRASE_START',
  RESET_WITHDRAWAL_SECRET_PHRASE_SUCCESS: 'RESET_WITHDRAWAL_SECRET_PHRASE_SUCCESS',
  RESET_WITHDRAWAL_SECRET_PHRASE_FAILURE: 'RESET_WITHDRAWAL_SECRET_PHRASE_FAILURE',
  // -----// GET_USER_UNIQUE_DEVICES //-----//
  GET_USER_UNIQUE_DEVICES_START: 'GET_USER_UNIQUE_DEVICES_START',
  GET_USER_UNIQUE_DEVICES_SUCCESS: 'GET_USER_UNIQUE_DEVICES_SUCCESS',
  GET_USER_UNIQUE_DEVICES_FAILURE: 'GET_USER_UNIQUE_DEVICES_FAILURE',
  // -----// DELETE_USER_UNIQUE_DEVICE //-----//
  DELETE_USER_UNIQUE_DEVICE_START: 'DELETE_USER_UNIQUE_DEVICE_START',
  DELETE_USER_UNIQUE_DEVICE_SUCCESS: 'DELETE_USER_UNIQUE_DEVICE_SUCCESS',
  DELETE_USER_UNIQUE_DEVICE_FAILURE: 'DELETE_USER_UNIQUE_DEVICE_FAILURE',
  // -----// GET_USER_WITHDRAWAL_WHITELIST_ADDRESSES //-----//
  GET_USER_WITHDRAWAL_WHITELIST_ADDRESSES_START:
    'GET_USER_WITHDRAWAL_WHITELIST_ADDRESSES_START',
  GET_USER_WITHDRAWAL_WHITELIST_ADDRESSES_SUCCESS:
    'GET_USER_WITHDRAWAL_WHITELIST_ADDRESSES_SUCCESS',
  GET_USER_WITHDRAWAL_WHITELIST_ADDRESSES_FAILURE:
    'GET_USER_WITHDRAWAL_WHITELIST_ADDRESSES_FAILURE',
};

export default types;
